import React from "react";

export default function Error({ message }) {
  return (
    <div className="w-full text-center mt-1 py-1 text-red-700 bg-red-300 ">
      <lord-icon
        src="https://cdn.lordicon.com/bmnlikjh.json"
        trigger="loop"
        colors="primary:#c71f16"
        state="hover-1"
        style={{
          verticalAlign: "middle",
          marginRight: "10px",
          width: "30px",
          height: "30px",
        }}
      ></lord-icon>
      {message}
    </div>
  );
}
